import React from "react";
import { PiCursorFill } from "react-icons/pi";
import styles from "./RemoteCursors.module.css";
function RemoteCursorOverlay({ cursor }) {
    return (React.createElement("div", { className: styles.container, style: { left: cursor.position.x, top: cursor.position.y } },
        React.createElement(PiCursorFill, { fill: cursor.color, className: styles.cursor }),
        React.createElement("div", { style: { background: cursor.color }, className: styles.name }, cursor.name)));
}
export default RemoteCursorOverlay;
